// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"tp-z","breadcrumbForward":"up-z","breadcrumbBack":"vp-z","selected":"wp-z"};